export default {
  methods:{
      fahrenheitToCelcius(temp){
         return (temp - 32) * (5/9)
      }
  }
}